import { Component, OnInit, HostListener } from '@angular/core';
import { I18nService } from '@app/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { AuthService } from '@app/auth.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { UserService } from '@app/user.service';
import { Observable } from 'rxjs';

declare var $: any;
declare var Captcha: any

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  error: string;
  isLoading = false;
  member_obj: any;
  obj_data_all: any;
  url: any;
  ip_add: any;
  captcha: any

  readonly DefaultRoute: string = "/mainmenu/ticketlist";

  constructor(private Auth: AuthService,
    private router: Router,
    private i18nService: I18nService,
    private util: UtilService,
    private apiService: ApiService,
    private UserService: UserService) {
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == "Enter") {
      this.Login();
    }
  }
  
  async ngOnInit() {
    document.body.className = 'hold-transition login-page';
    localStorage.removeItem("AgentBank_Profile");
    
    // step-1
    this.captcha = new Captcha($('#canvas'), {
      length: 6
    });
    // api
    //captcha.refresh();
    //captcha.getCode();
    // //captcha.valid("");

    // $('#valid').on('click', function() {
    //   const ans = captcha.valid($('input[name="code"]').val());
    //   alert(ans);
    //   captcha.refresh();
    // })

    //await this.CallApi();
    this.InitDropdownItems()
  }

  async CallApi() {
    return forkJoin([
    ]);
  }

  async InitDropdownItems() {
    Observable.forkJoin(
      this.apiService.get("master", "companyType"),
      this.apiService.get("master", "personalType"),
      this.apiService.getMasterAddress()
    ).subscribe(
      data => {
        localStorage.removeItem("companyType");
        localStorage.removeItem("personalType");
        localStorage.removeItem("address");

        localStorage.setItem("companyType", JSON.stringify(data[0]))
        localStorage.setItem("personalType", JSON.stringify(data[1]))
        localStorage.setItem("address", JSON.stringify(data[2]))
      },
      err => console.error(err)
    );
  }

  async Login() {
    var UserName = $('#username').val();
    var Password = $('#password').val();

    if (UserName == "") {
      this.util.WarningDialog("กรุณาระบุชื่อผู้ใช้");
      return;
    }
    if (Password == "") {
      this.util.WarningDialog("กรุณาระบุรหัสผ่าน");
      return;
    }

    const ans = this.captcha.valid($('input[name="code"]').val());

    if (ans) {
      var data: any = await this.Auth.LogIn(UserName, Password);
      if (data["RESMSG"] == "SUCCESS") {
        let Profile = await this.Auth.GetProfile(UserName);

        if (Profile[0].dpa_forcechangepassword == true) {
          $('#lblError').html('');
          $('#dlgChngPwd').modal({
            backdrop: 'static',
            keyboard: false
          });
        }
        else {
          localStorage.setItem("AgentBank_Profile", UserName);
          localStorage.setItem("AgentBank_UserID", Profile[0].dpa_agentbankuserid);
          this.router.navigate([this.DefaultRoute]);
          this.Auth.setLoggedIn(true);
        }
      }
      else {
        this.util.WarningDialog("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
        return;
      }

    }
    else {
      $('input[name="code"]').val("")
      this.captcha.refresh();
      $('input[name="code"]').css("background-color", "crimson")
    }
  }

  async CheckSession() {
    var str = '';
    $('#divData').html(str);
    var data = {}
    data['member_no'] = $('#txtUserName').val();
    var res: any = await this.apiService.postnotauthen('account', 'GetUserSession', data);
    this.util.ShowWaiting(false);
    console.log('res', res);
    var check = 0;
    if (res.isSuccess) {
      if (res.responseData != null) {
        if (res.responseData.length > 0) {
          check++;
          this.ip_add = res.responseData[0].ip_address;
        }
      }
    }
    if (check == 0) {
      var res2: any = await this.apiService.postnotauthen('account', 'InsertUserSession', data);
      this.VisitApp(this.url);
    } else {
      this.util.ErrorDialog("user นี้ถูกใช้งานอยู่ (ip:" + this.ip_add + ")");
    }
  }

  VisitApp(url: any) {
    // window.location.href = url;
    console.log('url', url);
    this.router.navigate([url]);
  }


  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  ForgetPassword() {
    $('#txtMemberNo').val($('#txtUserName').val());
    $('#txtOldPassword').val('');
    $('#txtNewPassword').val('');
    $('#txtConfirmNewPassword').val('');
    $('#lblError').html('');
    $('#lblSuccess').html('');
    $('#dlgForgetPassword').modal({ backdrop: 'static', keyboard: false });
  }

  async SavePassword() {
    let NewPwd = $('#txtNewPwd').val();
    let CurrPwd = $('#password').val();

    if (NewPwd == "") {
      $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่');
      return;
    }
    if (NewPwd == CurrPwd) {
      $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่ให้ต่างจากรหัสผ่านปัจจุบัน');
      return;
    }
    if (!this.UserService.IsValidatePassword(NewPwd))
    {
      $('#lblPwdError').html('**รหัสผ่านใหม่ไม่ตรงตามข้อกำหนด');
      return;
    }
    if (NewPwd != $('#txtConfirmPwd').val()) {
      $('#lblPwdError').html('**กรุณายืนยันรหัสผ่านให้ตรงกัน');
      return;
    }

    let UserName = $('#username').val();
    let Res = await this.UserService.ChangePassword(UserName, CurrPwd, NewPwd);
    if (Res["RESMSG"] == "SUCCESS") {
      let Profile = await this.Auth.GetProfile(UserName);
      localStorage.setItem("AgentBank_Profile", UserName);
      localStorage.setItem("AgentBank_UserID", Profile[0].dpa_agentbankuserid);
      this.Auth.setLoggedIn(true);
      this.util.SuccessDialog('บันทึกสำเร็จ');

      setTimeout(() => {
        $('#btnCloseDlg').click();
        this.router.navigate([this.DefaultRoute]);
      }, 1000);
    }
    else {
      this.util.ErrorDialog('บันทึกไม่สำเร็จ');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts